<template>
  <div class="board-chair-letter">
    <div class="board-chair-letter__background">
      <div class="grid-x grid-margin-x align-center">
        <div class="cell medium-11 large-9 xxlarge-8">
          <div
            class="board-chair-letter__wrapper"
            data-aos="fade-right"
            data-aos-duration="600"
            data-aos-offset="400"
          >
            <TextureOne class="board-chair-letter__texture-one" />
            <TextureTwo class="board-chair-letter__texture-two" />
            <TextureThree class="board-chair-letter__texture-three" />
            <h2 class="board-chair-letter__heading">A Letter from our Board Chair</h2>
            <p>
              While 2024 was a year of conflict and turmoil on a global scale, SVMIC remains a reliable source of stability and support for doctors and other healthcare providers. Our commitments are to provide strong legal defense, to deliver the high level of customer service that doctors deserve, and to be excellent stewards of the resources our policyholders entrust to us. As a doctor-owned and doctor-led company, our sole priority is to provide the best support possible for our policyholders and to do so as efficiently as possible.
            </p>
            <p>
              SVMIC's priorities remain the same, but the strategies we use to achieve them are evolving. We're upgrading our core systems to provide a more modern platform for our underwriting, claims, and financial reporting. We've invested in our claims analytics capabilities to promptly address emerging threats through our risk management efforts. We're constantly improving our online resources and capabilities, in accordance with your changing preferences. In this report, you will learn about these and other investments and how SVMIC is growing with you.
            </p>
            <p>
              In May of 2024, I was grateful to be elected chair of SVMIC's Board of Directors after Dr. Hugh Francis reached age 65, at which point our bylaws require him to relinquish that role. I want to thank Dr. Francis for his excellent leadership as chair over the last decade. Throughout his more than 30 years of service to SVMIC, he has provided thoughtful guidance, asked difficult questions, supported his colleagues in challenging times, and helped us achieve many successes. I've enjoyed the privilege of working with Dr. Francis and am glad he will continue to serve as a director.
            </p>
            <p>
              Doctors routinely encounter new and unforeseen challenges. We thrive by continually learning, adapting, and developing new skills. SVMIC is committed to supporting your success, and we are honored to be your partner. If there is a way for SVMIC to serve you better, please don't hesitate to let us know.
            </p>
            <div class="board-chair-letter-signature">
              <div
                class="board-chair-letter-signature__photo"
                data-aos="fade-right"
                data-aos-duration="1000"
                data-aos-offset="100"
              >
              </div>
              <div
                class="board-chair-letter-signature__subtext"
                data-aos="fade-left"
                data-aos-duration="1000"
                data-aos-offset="100"
              >
                <h3>Matthew L. Perkins, MD</h3>
                <p>Chair, SVMIC Board of Directors</p>
                <p>Internal Medicine and Pediatrics</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextureOne from '@/assets/texture-board-chair.svg';
import TextureTwo from '@/assets/texture-board-chair-2.svg';
import TextureThree from '@/assets/texture-board-chair-3.svg';

export default {
  name: 'HomeLetter',
  components: {
    TextureOne,
    TextureTwo,
    TextureThree,
  }
};
</script>
